import React from 'react'

const SvgAudio = props => (
  <svg width="1em" height="1em" viewBox="0 0 99 99" fill="none" {...props}>
    <circle
      cx={49.5}
      cy={49.5}
      r={49.5}
      fill="url(#Audio_svg__paint0_linear)"
    />
    <path
      d="M79.933 51.816v-.267c0-1.273-.2-5.892-.335-7.298C77.858 28.449 65.002 17 49.067 17c-8.035 0-15.6 3.013-21.359 8.503-5.69 5.49-9.105 13.056-9.574 21.158-.067.87-.134 3.08-.134 4.419v17.14a6.286 6.286 0 0 0 6.294 6.294h5.021a6.286 6.286 0 0 0 6.294-6.294V52.084a6.286 6.286 0 0 0-6.294-6.294h-4.62c1.273-12.855 11.584-22.43 24.439-22.43 12.587 0 22.764 9.107 24.17 21.627 0 .2.067.469.067.803h-4.62a6.286 6.286 0 0 0-6.293 6.294V68.22a6.286 6.286 0 0 0 6.294 6.294h4.954A6.286 6.286 0 0 0 80 68.22V52.084c-.067-.067-.067-.2-.067-.268zm-54.166.402h2.008c.737 0 1.34.603 1.34 1.34v13.19c0 .736-.603 1.338-1.34 1.338h-2.008c-.737 0-1.34-.602-1.34-1.339v-13.19c0-.736.603-1.339 1.34-1.339zm47.805 14.53c0 .736-.602 1.338-1.339 1.338h-2.008c-.737 0-1.34-.602-1.34-1.339v-13.19c0-.736.603-1.339 1.34-1.339h2.008c.737 0 1.34.603 1.34 1.34v13.19z"
      fill="#fff"
    />
    <defs>
      <linearGradient
        id="Audio_svg__paint0_linear"
        x1={32.063}
        y1={-7.313}
        x2={85.14}
        y2={84.15}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#AA3AB4" />
        <stop offset={1} stopColor="#7EB6F8" />
      </linearGradient>
    </defs>
  </svg>
)

export default SvgAudio
